export const websiteTitle = "Kombucha Brewing Co";

export const apiConfig = {
    baseURL: process.env.REACT_APP_API_BASE_URL,
};
